export default {
      id: "status-pending_but_expired-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#status-pending_but_expired",
      toString: function () {
        return this.url;
      }
    }